import React, { Component } from 'react';
import { connect } from 'react-redux';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import {getLastArendenByAfid,setofUpdatedashboardArende,decrypt,encrypt} from 'actions'
import { isEmpty,isEqual,isUndefined } from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment-timezone'
import axios from 'util/ApiDashboard'
import IntlMessages from 'util/IntlMessages';

function mapStateToProps({auth,DashBoard,accountsData}) {
  const { authUser} = auth;
  const { updatedashboardArende} = accountsData;
    const { LastArenden,DashboardAnpassadFilterOption} = DashBoard;
    return {
        authUser,LastArenden,DashboardAnpassadFilterOption,updatedashboardArende
    };
}

function mapDispatchToProps(dispatch) {
  return {
      getLastArendenByAfid: (userid,Afid,DashboardAnpassadFilterOption,intervaltype) => dispatch(getLastArendenByAfid(userid,Afid,DashboardAnpassadFilterOption,intervaltype)),
      setofUpdatedashboardArende: () => dispatch(setofUpdatedashboardArende()),
      decrypt: (encryptedData, iv) => dispatch(decrypt(encryptedData, iv)),
      encrypt: (data) => dispatch(encrypt(data)),
      dispatch
  }
}
const useStyles = theme => ({
  root: {
      '&::-webkit-scrollbar': {
          width: '5px'
        },
         
        '&::-webkit-scrollbar-track': {
          backgroundColor: 'transparent'
        },
         
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#12484B',
          outline: '1px solid transparent'
        }
   },
});
const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: '#12585E',
      // backgroundColor: '#14484D',
    },
  },
}))(TableRow);

class ClosedDeals extends Component {
  state={
    LastArenden:[],
    intervaltype:this.props.intervaltype,
    done: false
}
intervalID = null
componentDidMount=()=>{
  const userid = this.props.authUser.user_id;
  const Afid = this.props.authUser.user_Afid;
  axios.get(`kontos/DashBoard/getLABYAF`,
  { params:encrypt(JSON.stringify({
      Afid:Afid,
      FilterOption:[...this.props.filterOptionsArr, ...this.props.DashboardAnpassadFilterOption],
      intervaltype:this.props.intervaltype,
      userid:userid
    }))
  })
  .then(res => {
    if(res.data.success){
      let endata = decrypt(res.data.encryptedData,res.data.iv)
      let ndate = JSON.parse(endata)
      this.setState({ 
        LastArenden:ndate.results.LastArenden,
        intervaltype:this.props.intervaltype
     });
     this.initiateInterval() 
        // this.setState({done: true}) 
      } 
   })


  
    
  }
  initiateInterval() {
      clearInterval(this.intervalID);
      this.intervalID= null
  this.intervalID = setInterval(
    () => {          
        this.setState({done: false}) 
        const userid = this.props.authUser.user_id;
        const Afid = this.props.authUser.user_Afid;
        axios.get(`kontos/DashBoard/getLABYAF`,
        { params:encrypt(JSON.stringify({
            Afid:Afid,
            FilterOption:[...this.props.filterOptionsArr, ...this.props.DashboardAnpassadFilterOption],
            intervaltype:this.props.intervaltype,
            userid:userid
          }))
        })
        .then(res => {
          if(res.data.success){
            let endata = decrypt(res.data.encryptedData,res.data.iv)
            let ndate = JSON.parse(endata)
            this.setState({ 
              LastArenden:ndate.results.LastArenden,
              intervaltype:this.props.intervaltype
           });
           this.initiateInterval() 
              // this.setState({done: true}) 
            } 
         })
    },
    180000
);
   
}
componentWillUnmount() {
  clearInterval(this.intervalID);
  this.intervalID= null
}
componentDidUpdate=()=>{
  const userid = this.props.authUser.user_id;
  const Afid = this.props.authUser.user_Afid;
  if(parseInt(this.props.updatedashboardArende) === 1){
    axios.get(`kontos/DashBoard/getLABYAF`,
    { params:encrypt(JSON.stringify({
        Afid:Afid,
        FilterOption:[...this.props.filterOptionsArr, ...this.props.DashboardAnpassadFilterOption],
        intervaltype:this.props.intervaltype,
        userid:userid
      }))
    })
    .then(res => {
      if(res.data.success){
        let endata = decrypt(res.data.encryptedData,res.data.iv)
        let ndate = JSON.parse(endata)
        this.setState({ 
          LastArenden:ndate.results.LastArenden,
          intervaltype:this.props.intervaltype
       });
       this.initiateInterval() 
          // this.setState({done: true}) 
        } 
     })
    this.props.setofUpdatedashboardArende()
  }
  if(!isEqual([...this.props.filterOptionsArr, ...this.props.DashboardAnpassadFilterOption],this.state.DashboardAnpassadFilterOption))
  {
    this.setState({done: false}) 
    this.setState({
      DashboardAnpassadFilterOption:[...this.props.filterOptionsArr, ...this.props.DashboardAnpassadFilterOption] 
  })
  
  axios.get(`kontos/DashBoard/getLABYAF`,
  { params:encrypt(JSON.stringify({
      Afid:Afid,
      FilterOption:[...this.props.filterOptionsArr, ...this.props.DashboardAnpassadFilterOption],
      intervaltype:this.props.intervaltype,
      userid:userid
    }))
  })
  .then(res => {
    if(res.data.success){
      let endata = decrypt(res.data.encryptedData,res.data.iv)
      let ndate = JSON.parse(endata)
      this.setState({ 
        LastArenden:ndate.results.LastArenden,
        intervaltype:this.props.intervaltype
     });
     this.initiateInterval() 
        // this.setState({done: true}) 
      } 
   })
  }
  if(this.state.intervaltype !== this.props.intervaltype){
    axios.get(`kontos/DashBoard/getLABYAF`,
    { params:encrypt(JSON.stringify({
        Afid:Afid,
        FilterOption:[...this.props.filterOptionsArr, ...this.props.DashboardAnpassadFilterOption],
        intervaltype:this.props.intervaltype,
        userid:userid
      }))
    })
    .then(res => {
      if(res.data.success){
        let endata = decrypt(res.data.encryptedData,res.data.iv)
        let ndate = JSON.parse(endata)
        this.setState({ 
          LastArenden:ndate.results.LastArenden,
          intervaltype:this.props.intervaltype
       });
       this.initiateInterval() 
          // this.setState({done: true}) 
        } 
     })
  }
 /*   setTimeout(()=> {
        
    }, 30000);*/
}
formatNumber=(number)=>{
      return `${(number).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} ${this.props.Flags.ValueInNotyfile<=1?this.props.Flags.Enhet:this.props.Flags.Valuta}`
}
  render() {
    const { classes } = this.props;
    return (
    <div className="text-center potition-relative" style={{ color: isUndefined(this.props.FontColor)?'#fff':this.props.FontColor, height: 'calc(100% - 12px)', paddingBottom: 20, overflow: 'hidden' }}>
      <div className="d-flex justify-content-center row" style={{ marginTop: '12px' }}>
          <h2 className="col" style={{fontWeight:"500"}}><b><IntlMessages id="DashBoard.Errand.Latest"/></b></h2>
        </div>
          <div className="d-flex justify-content-center" style={{height: 'calc(100% - 50px)'}}>
          <div className={classes.root}
      style={{width:'95%',overflowY: "scroll", height: '100%'}}>
          {/* style={{width:'95%',overflowY: "auto",height: "400px"}}> */}
          <Table>
            <TableBody>
              {
                !isEmpty(this.state.LastArenden)?
              this.state.LastArenden.map(n => {
                return (
                  <StyledTableRow key={n.index}>
                    <TableCell align="left" 
                    style={{ fontWeight: '400', paddingTop: '5px', paddingBottom: '5px', color:isUndefined(this.props.FontColor)?'#fff':this.props.FontColor, borderBottom: '1px solid transparent', fontSize: isEmpty(this.props.fs) ? '14px' : this.props.fs }}>
                      {`#${n.Arendenr} ${String(n.Beskrivning).slice(0, 30)}${String(n.Beskrivning).length > 30 ? '...' : ''}`}
                      </TableCell>
                    <TableCell align="right" style={{ fontWeight: '400', paddingTop: '5px', paddingBottom: '5px',color:isUndefined(this.props.FontColor)?'#fff':this.props.FontColor, borderBottom: '1px solid transparent', fontSize: isEmpty(this.props.fs) ? '14px' : this.props.fs }}>{moment(n.sdate).format('YYYY-MM-DD')}</TableCell>
                    
                  </StyledTableRow>
                );
              }):""}
            </TableBody>
          </Table>
        </div>
        </div>
          <div className="d-flex justify-content-end w-100" style={{position: 'absolute', bottom: 4, right: 16,color: isUndefined(this.props.FontColor)?'#fff':this.props.FontColor}}>
              <p>{this.props.getIntervalTypeText(this.props.intervaltype)}</p>
          </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,mapDispatchToProps
)(withStyles(useStyles)(ClosedDeals));
